import React from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { toggleSpinner } from 'actions/appAction';

import { INCREASE_LIMITS_DOCUMENTS_SELECTED } from 'constants/amplitude/AmplitudeEvents';
import { DOCUMENT_TYPE } from 'constants/amplitude/AmplitudeParamName';
import { LIECHTENSTEIN, UK } from 'constants/WellKnownCountries';

import amplitude from 'amplitude-js';

import { PromoRow } from '../../PromoRow/PromoRow';
import { LightDiskBadge } from '../LightDiskBadge/LightDiskBadge';
import { LightPanel } from '../LightPanel/LightPanel';
import { DiskBadgeWrapper, PanelFrame, PanelRow } from '../LightPanel/styles';
import { LightText } from '../LightText/LightText';

const LightOnfidoDoc = ({ userType = 'ga', ...props }) => {
    const [searchParams] = useSearchParams();
    const addParamToUrl = searchParams ? '?' + searchParams : '';

    let flagName = props.flagName;
    let secondFlagName = null;
    if (props.type === 'driving_licence') {
        if (props.userCountryId === UK) {
            flagName = 'gb';
            secondFlagName = 'eu';
        } else if (props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    } else if (props.type === 'residence_permit') {
        if (props.userCountryId === UK) {
            flagName = 'gb';
        } else if (props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    } else if (props.type === 'national_identity_card') {
        if (props.userCountryId === UK || props.userCountryInEEA || props.userCountryId === LIECHTENSTEIN) {
            flagName = 'eu';
        }
    }

    return (
        <PromoRow indent="32px">
            <LightPanel
                type="link"
                href={`/auth/kyc/${userType}/onfido/frame/${props.type}` + addParamToUrl}
                onClick={(e) => {
                    if (props.onClick) {
                        e.preventDefault();
                        props.onClick(props.type);
                    } else {
                        amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SELECTED, { [DOCUMENT_TYPE]: props.type });
                        props.toggleSpinner(true);
                    }
                }}
                isBordered
                hasBorderRadius
            >
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <LightDiskBadge
                            iconName={props.type === 'passport' ? 'passport' : 'id-card'}
                            variant="secondary"
                            flagName={flagName}
                            secondFlagName={secondFlagName}
                            noBorder
                        />
                    </DiskBadgeWrapper>
                    <div>
                        <PanelRow>
                            <LightText datatype={props.type}>{props.title}</LightText>
                        </PanelRow>
                        {props.subTitle && (
                            <PanelRow>
                                <LightText size="secondary" color="mediumGray">
                                    {props.subTitle}
                                </LightText>
                            </PanelRow>
                        )}
                    </div>
                </PanelFrame>
            </LightPanel>
        </PromoRow>
    );
};

export default connect(null, { toggleSpinner })(LightOnfidoDoc);
